export default __webpack_public_path__ + "static/media/contact-qr.0523f150.jpg";